import { BaseAPI } from '@/api/base.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import { TipoDocumento } from '@/models/tipo-documento';
export class TipoDocumentoAPI extends BaseAPI<TipoDocumento> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api_dash/v1/document_types`;
  }

  public list(params: any): AxiosObservable<TipoDocumento[]> {
    return this.axios.get(`${this.apiUrl}`, { params: this.buildFiltered(params) })
  }

  public show(id: number): AxiosObservable<TipoDocumento> {
    return this.axios.get(`${this.apiUrl}/${id}`)
  }

  public update(id: number, body: any): AxiosObservable<TipoDocumento> {
    return this.axios.patch(`${this.apiUrl}/${id}`, body)
  }
}
